import { useState, useCallback } from "react";

export function useReply() {
    const [replyingTo, setReplyingTo] = useState(null);

    const startReply = useCallback((msg) => {
        setReplyingTo(msg);
    }, []);

    const cancelReply = useCallback(() => {
        setReplyingTo(null);
    }, []);

    return { replyingTo, startReply, cancelReply };
}